import { brand } from "@/mocks/site";

const pillars = [
  {
    icon: "ri-file-search-line",
    title: "按流程拆解，而不是按情绪",
    desc: "同一件事先从「谁先开口、谁签字、谁收钱」还原顺序，再看结论。顺序清楚了，套路自然就露出来了。",
  },
  {
    icon: "ri-scales-3-line",
    title: "只写可对照的环节",
    desc: "去掉可识别的企业名称，保留任何人都可能遇到的步骤与话术。你在别处遇到相似场景，也能直接套用。",
  },
  {
    icon: "ri-compass-3-line",
    title: "给方法，不给恐吓",
    desc: "每篇档案结尾都附提问清单和避坑要点，读完能立刻用在下一份合同、下一次谈话里。",
  },
];

export default function PropositionSection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-[1240px] mx-auto px-4 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <p className="flex items-center gap-2 text-xs font-medium tracking-[0.24em] uppercase text-primary-600 mb-4">
              <span className="w-6 h-px bg-primary-400" aria-hidden="true"></span>
              我们做什么
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
              黑暗不是秘密，
              <br />
              只是没人把环节讲清楚
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              {brand.name}不贩卖内幕故事。我们相信绝大多数「黑幕」都不是玄学，而是一套设计过的流程——报低价的、改数据的、催你签字的那几句话，位置都差不多。把位置标出来，你就有了判断的支点。
            </p>
            <div className="mt-8 p-5 md:p-6 rounded-lg bg-secondary-50 border border-secondary-200">
              <p className="font-heading text-base font-semibold text-foreground-950 mb-2">
                一句话概括我们的立场
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed">
                「{brand.promise}」——不替你做决定，只把你决策时缺的那块信息补上。
              </p>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4 md:gap-5">
            {pillars.map((pillar, index) => (
              <article
                key={pillar.title}
                className={`flex gap-5 p-5 md:p-6 rounded-lg border transition-colors ${
                  index === 1
                    ? "bg-primary-50 border-primary-200"
                    : "bg-background-100 border-background-200"
                }`}
              >
                <span
                  className={`shrink-0 w-12 h-12 flex items-center justify-center rounded-md text-2xl ${
                    index === 1
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-50 text-primary-600"
                  }`}
                >
                  <i className={pillar.icon} aria-hidden="true"></i>
                </span>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                    {pillar.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{pillar.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}